import(/* webpackMode: "eager" */ "/home/ubuntu/survey-monkey-pro/apps/web/app/global-error.tsx");
